import TableContainer from "Components/Common/TableContainer";
import CustomButton from "Components/Custom/CustomButton";
import { useAppDispatch, useAppSelector } from "Components/Hooks/hooks";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Input } from "reactstrap";
import { getPresetQuoteList } from "slices/thunks";
import { PresetQuotePayload } from "types/preset.api";

interface SelectPresetQuoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: (template: PresetQuotePayload | null) => void;
}

const SelectPresetQuoteModal = ({
  isOpen,
  onClose,
  onContinue,
}: SelectPresetQuoteModalProps) => {
  const [selectedRow, setSelectedRow] = useState<PresetQuotePayload | null>(
    null
  );
  const dispatch = useAppDispatch();
  const { presetQuoteList, meta, isLoading } = useAppSelector(
    (state) => state?.presetQuote
  );
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchText, setSearchText] = useState<string>("");

  //Preset Quote Get Api Call
  useEffect(() => {
    const params = searchText
      ? { search: searchText }
      : { pageNo: currentPage };
    dispatch(getPresetQuoteList(params));
  }, [currentPage, dispatch, searchText]);

  console.log("Selected row", selectedRow);

  const columns = useMemo(
    () => [
      {
        header: "ACTION",
        accessorKey: "select",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <Input
            type="radio"
            name="quoteSelect"
            checked={selectedRow?.id === cell.row.original?.id}
            onChange={() => setSelectedRow(cell.row.original)}
            className="preset-radio"
          />
        ),
      },
      {
        header: "TEMPLATE NAME",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span className="fw-normal text-black2D fs-14 font-primary text-wrap line-clamp-2">
            {cell.getValue()}
          </span>
        ),
      },
      {
        header: "ITEMS",
        accessorKey: "items_count",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span className="fw-normal text-black2D fs-14 font-primary text-wrap line-clamp-2">
            {cell.getValue()}
          </span>
        ),
      },
      {
        header: "DESCRIPTION",
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span className="fw-normal text-black2D fs-14 font-primary text-wrap line-clamp-2">
            {cell.getValue() ? cell.getValue() : "-"}
          </span>
        ),
      },
    ],
    [selectedRow]
  );

  const handlePageChange = useCallback((page: number) => {
    setCurrentPage(page);
  }, []);

  const handleSearch = useCallback((text: string) => {
    setSearchText(text);
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        onClose();
        setSelectedRow(null);
      }}
      centered
      size="xl"
      contentClassName="br-7"
    >
      {/* Header */}
      <ModalHeader
        toggle={() => {
          onClose();
          setSelectedRow(null);
        }}
        className="fw-medium fs-16 text-black2D p-3 bg-greyF5"
      >
        Select Preset Quote
      </ModalHeader>

      {/* Table Section */}
      <ModalBody className="px-4 pb-0 overflow-hidden max-w-100">
        <div className="p-2">
          <TableContainer
            isGlobalFilter={true}
            columns={columns}
            data={presetQuoteList}
            tableClass="align-middle table-nowrap table-borderless preset-modal"
            thClass="text-grey89 fw-medium fs-14 font-primary bg-greyF5 sticky-header"
            theadClass="table-light"
            SearchPlaceholder="Search preset quotes"
            searchClass="ms-2"
            // divClass="mx-n4"
            divClass="mx-n4 table-scroll-container"
            onPageChange={handlePageChange}
            customPageSize={meta?.per_page}
            totalPages={meta?.last_page}
            currentPage={meta?.current_page}
            fromPage={meta?.from}
            toPage={meta?.to}
            totalItems={meta?.total}
            isInitialLoading={isLoading && !presetQuoteList?.length}
            // isPaginationLoading={isLoading && presetQuoteList?.length > 0}
            onSearch={handleSearch}
            onRowClick={(item) => {
              setSelectedRow(item);
            }}
          />
        </div>
      </ModalBody>

      {/* Divider */}
      <div className="my-3 divider" />

      {/* Bottom Actions */}
      <ModalFooter className="justify-content-start mt-0 pt-0">
        {/* BUTTON */}
        <CustomButton
          className="bg-primary text-white br-7 px-3"
          type="button"
          text="Continue"
          onClick={() => {
            onContinue(selectedRow);
          }}
        />
      </ModalFooter>
    </Modal>
  );
};

export default SelectPresetQuoteModal;
